<template>
    <div class="card-circolare-automatica">
        <div class="header bg-csenBlue-100 dark:bg-csenBlue-800 dark:text-white border-b border-b-csenBlue-200 dark:border-b-csenBlue-400 hover:bg-csenBlue-200 dark:hover:bg-csenBlue-600 transition text-csenBlue-900 px-6 py-4 md:grid md:grid-cols-5 ">
            <div @click="toggle"  class="cursor-pointer col-span-3 text-base font-bold my-auto">
                <h3>{{ titolo }}</h3>
            </div>
            <div class="col-span-2 flex justify-end gap-4">
                <v-btn
                    id="modifica-rinnovo-automatico"
                    class="!bg-orange-100 !text-csenOrange-600 dark:!bg-orange-500 dark:!text-white !inline-flex !justify-center !content-center !px-auto !rounded-md !hover:bg-csenOrange-500 !hover:text-white !transition"
                    @click="openCircolariDialog()"
                >
                    <EditIcon></EditIcon>
                    <span class="text-sm ml-2 tracking-normal">Modifica</span>
                </v-btn>
                <v-btn id="mostra-rinnovo-automatico" icon @click="toggle">
                    <v-icon class="!text-csenBlue-900 dark:!text-csenBlue-200 !z-50">{{ isOpen ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
                </v-btn>
            </div>
        </div>
        <div v-if="isOpen" @click="openCircolariDialog()" class="content cursor-pointer">
            <slot></slot>
        </div>

        <!-- DIALOG CIRCOLARE -->
        <template>
            <v-dialog v-model="circolariDialog" width="1200px" persistent>
                <!-- @click:outside="closeCircolariDialog" -->
                <v-card plain class="dark:!bg-csenBlue-900" >
                    <v-card-title class="font-bold text-2xl py-6 pl-8 dark:!bg-csenBlue-800 border-b border-b-gray-200 dark:border-none">
                        <span class="flex-grow">
                            <h2>
                                Modifica: <span class="text-csenBlue-700 dark:text-csenBlue-200">{{ titolo }}</span>
                            </h2>
                        </span>
                        <v-btn class="!text-gray-900 dark:!text-csenBlue-200" icon @click="closeCircolariDialog">
                            <CloseIcon />
                        </v-btn>
                    </v-card-title>
                    <v-card-text class="!m-0 !p-0">
                        <v-form v-model="validForm" ref="form">
                            <div class="my-5 mx-8">
                                <div v-if="mostraImpostazioniOrario" class="container mx-auto px-4">
                                    <div class="flex ">
                                        <!-- GIORNO -->
                                        <div class="w-full sm:w-1/3 px-4 ">
                                            <v-text-field
                                                v-model="dataPrevistaGestita"
                                                label="Imposta la data di invio della circolare"
                                                type="date"
                                                outlined
                                                :rules="[rules.required]"
                                                @input="circolareModificata = true"
                                            ></v-text-field>
                                        </div>

                                        <!-- ORA  -->
                                        <div class="w-full sm:w-1/3 px-4 ">
                                            <v-text-field
                                                v-model="oraPrevistaGestita"
                                                label="Imposta l'ora di invio della circolare"
                                                outlined
                                                :rules="[ 
                                                    rules.required,
                                                    (v) => !!v || 'Imposta ora di invio della circolare', 
                                                    (v) => /^([01]\d|2[0-3]):([0-5]\d)$/.test(v) || 'Formato ora non valido (HH:mm)' 
                                                ]"
                                                hint="Formato HH:mm"
                                                @input="circolareModificata = true"
                                            ></v-text-field>
                                        </div>

                                        <!-- ANNO -->
                                        <div class="w-full sm:w-1/3 px-4 ">
                                            <v-select
                                                v-model="datiClonati.anno_rinnovo_riferimento"
                                                :items="anniDisponibili"
                                                label="Seleziona l'anno di riferimento del rinnovo"
                                                outlined
                                                :rules="[rules.required]"
                                                @change="circolareModificata = true"
                                            ></v-select>
                                        </div>
                                    </div>
                                </div>
                                <v-divider v-if="mostraImpostazioniOrario"></v-divider>
                                
                                <!-- ATTIVA -->
                                <div v-if="mostraIsAttiva" class="mx-8 flex justify-between">
                                    <div class="my-auto text-lg font-semibold text-csenBlue-950 dark:text-white"> Non attivo / Attivo </div>
                                    <div>
                                        <v-switch
                                            v-model="datiClonati.is_attiva"
                                            color="primary"
                                            class="pointer"
                                            @change="circolareModificata = true"
                                        ></v-switch>
                                    </div>
                                </div>
                                <v-divider v-if="mostraIsAttiva"></v-divider>

                                <!-- Componente Modello Email -->
                                <div class="mt-12">
                                    <v-autocomplete
                                        autocomplete="none"
                                        label="Seleziona un modello email"
                                        v-model="datiClonati.modello_email_id"
                                        :items="modelliEmailDisponibili"
                                        item-value="id"
                                        item-text="nome"
                                        outlined 
                                        clearable
                                        :rules="[rules.required]"
                                        @change="circolareModificata = true"
                                    ></v-autocomplete>
                                        <span  class="!font-sans text-lg text-csenBlue-950 dark:text-csenBlue-100 mb-6 pt-3 font-semibold" v-if="datiClonati.modello_email_id">🔍 La seguente è un'anteprima dell'email che verrà utilizzata:</span><br/>
                                    <ModelloEmailComponent 
                                        v-if="datiClonati.modello_email_id" 
                                        :id="datiClonati.modello_email_id" 
                                        :only-view="true">
                                    </ModelloEmailComponent>
                                </div>

                            </div>
                        </v-form>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="p-4 justify-end !bg-gray-200 dark:!bg-csenBlue-800 sticky bottom-0 z-40">
                        <v-btn class="!bg-white!tracking-wider !py-5 !px-5" text @click="closeCircolariDialog">Annulla</v-btn>
                        <v-btn class="!bg-csenBlue-900 dark:!bg-csenGreen-500 !text-white !tracking-wider !py-5 !px-5" text @click="modificaCircolare()">Salva modifiche</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
        
    </div>
</template>
<script>
    import ModelloEmailComponent from './ModelloEmailComponent.vue';

    import mixin from '../mixin';
	import store from '../store';

    export default {
        components: { ModelloEmailComponent },
        props: ['modelliEmailDisponibili', 'dati', 'titolo', 'mostraImpostazioniOrario', 'mostraIsAttiva'],
		mixins: [mixin],
        data() {
            return {
                circolariDialog: false,
                isActive : true,
                isOpen: false,
                date: '',
                time: '',
                year: new Date().getFullYear(),
                anniDisponibili: this.getYears(),

                dataPrevistaGestita: '',
                oraPrevistaGestita: '',

                validForm: null,

                datiClonati: null,

                circolareModificata: false,
            };
        },
        created(){            
            this.datiClonati = JSON.parse(JSON.stringify(this.dati));
            this.init(this.datiClonati);
        },
        watch: {
            // Se una circolare cambia, i dati in essa contenuti potrebbero cambiare
            dati: {
                handler(newVal, oldVal){
                    this.datiClonati = JSON.parse(JSON.stringify(this.dati));
                    this.init(this.datiClonati);
                },  
                deep: true
            }
        },
        methods: {
            init(datiIniziali){
                this.circolareModificata = false;

                if(Object.keys(datiIniziali).length > 0 && datiIniziali.data_invio != null){
                    this.dataPrevistaGestita = datiIniziali.data_invio.split(" ")[0]
                    // this.oraPrevistaGestita = this.dati.data_invio.split(" ")[1] // Non deve mostrare i secondi

                    const dataOggetto = new Date(datiIniziali.data_invio);
                    const ore = dataOggetto.getHours().toString().padStart(2, '0');
                    const minuti = dataOggetto.getMinutes().toString().padStart(2, '0');
                    this.oraPrevistaGestita = `${ore}:${minuti}`
                }
            },
            toggle() {
                this.isOpen = !this.isOpen;
            },      
            openCircolariDialog() {
                // Reimposto i dati passati inizialmente (this.dati)
                this.datiClonati = JSON.parse(JSON.stringify(this.dati));
                this.init(this.datiClonati);

                this.circolariDialog = true; 
            },
            closeCircolariDialog(daConfermare = true){
                if(this.circolareModificata && daConfermare){
					store.commit('mostraDialogConferma', 
						{
							titolo: 'Esci senza salvare le modifiche',
							testo:'Sono presenti delle modifiche, vuoi uscire senza salvarle?', 
							onConferma:()=>{
								this.circolariDialog = false;
								store.commit('nascondiDialogConferma');
							}, 
							onAnnulla:()=>{
								store.commit('nascondiDialogConferma');
							}
						}
					)
				} else {
					this.circolariDialog = false;
				}
            },
            getYears() {
                const currentYear = new Date().getFullYear();
                return Array.from({ length: 4 }, (_, i) => (currentYear + 1 - i).toString());
            },
            valida(){
                if(this.$refs['form'].validate())
                    return true;
                return false
            },
            modificaCircolare(){
                if(!this.valida()){
                    store.commit('mostraSnack', {messaggio: 'Alcuni campi obbligatori non sono compilati correttamente', tipo: 'error'})
                    return
                }
                
                this.datiClonati.data_invio = this.dataPrevistaGestita + " " + this.oraPrevistaGestita

                axios.patch(`circolari/${this.datiClonati.id}`, {'tipo': this.tipo, ...this.datiClonati})
                    .then(res => {
                        store.commit('mostraSnack', {messaggio: 'Circolare automatica modificata con successo', tipo: 'success'})
                        this.$emit('modello-email-modificato');
                        this.$emit('circolare-modificata');

                        this.closeCircolariDialog(false);
                    })
            }
        }
    }
</script>
